export default __webpack_public_path__ + "static/media/gold-silver-navigation-background.6ad7df7c.jpeg";